import { Injectable, signal } from '@angular/core';
import { IProject } from '../../@core/models/model';
import { CONTRACT_TYPE } from '../../contract-management/models/contract-management.model';
import { SORT_ORDER } from '../../@shared/models/table.models';
import { ContractService, IContractResponse } from '../../contract-management/services/contracts.service';
import { IProjectFilter, ProjectService } from '../../contract-management/services/project.service';

/*
 * Single source for recent projects and documents used by:
 * - Sidebar (app-layout) for menu items
 * - Explore page for "Recent projects" and "Recent documents"
*/

@Injectable({ providedIn: 'root' })
export class RecentItemsService {
  readonly projects = signal<IProject[]>([]);
  readonly documents = signal<IContractResponse[]>([]);
  readonly totalProjects = signal(0);
  readonly totalDocuments = signal(0);
  readonly loadingProjects = signal(false);
  readonly loadingDocuments = signal(false);

  constructor(
    private projectService: ProjectService,
    private contractService: ContractService
  ) { }

  loadProjects(skip = 0, limit = 5): void {
    this.loadingProjects.set(true);
    const filters: IProjectFilter = {
      active: true,
      sortField: 'updatedAt',
      sortOrder: SORT_ORDER.DESC
    };
    this.projectService.getProjects(skip, limit, filters).subscribe(res => {
      this.loadingProjects.set(false);
      if (res.success) {
        this.projects.set(res.data.projects ?? []);
        this.totalProjects.set(res.data.totalRecords ?? 0);
      } else {
        this.projects.set([]);
        this.totalProjects.set(0);
      }
    });
  }

  loadDocuments(skip = 0, limit = 5): void {
    this.loadingDocuments.set(true);
    const filters = {
      type: CONTRACT_TYPE.ALL,
      name: '',
      skip,
      limit,
      sortField: 'updatedAt',
      sortOrder: SORT_ORDER.DESC
    };
    this.contractService.getContracts(filters).subscribe(res => {
      this.loadingDocuments.set(false);
      if (res?.success) {
        const list = res.data?.contracts ?? [];
        this.documents.set(list as IContractResponse[]);
        this.totalDocuments.set(res.data?.total ?? 0);
      } else {
        this.documents.set([]);
        this.totalDocuments.set(0);
      }
    });
  }
}
